import z from "zod";

/**
 * ItemChecklistMaquinaEquipSchema
 */

export const ItemChecklistMaquinaEquipSchema = z.object({
  ordem: z.coerce.string().nonempty('Este campo deve ser preenchido!'),
  codigo: z.coerce.string().nonempty('Este campo deve ser preenchido!'),
  descricao: z.coerce.string().nonempty('Este campo deve ser preenchido!'),

});

/**
 * ItemChecklistMaquinaEquipForm
 */

export type ItemChecklistMaquinaEquipForm = z.infer<typeof ItemChecklistMaquinaEquipSchema>;